export enum UserStatusType {
  Active = 'active',
  Blocked = 'blocked',
  Deleted = 'deleted',
}
